/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useInView } from 'react-intersection-observer';
// eslint-disable-next-line no-shadow
import Image, { ImageProps } from 'next/image';

export const PLACEHOLDER_IMAGE = '/assets/images/placeholder.png';

export type ImageOptimizedProps = Omit<
  ImageProps,
  'loading' | 'lazyBoundary' | 'lazyRoot'
> & {
  rootMargin?: string;
  root?: Element;
};

export const ImageOptimized: React.FC<ImageOptimizedProps> = ({
  rootMargin = '1000px',
  root = null,
  ...props
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    root,
    rootMargin,
  });

  return (
    <div ref={ref} id="inline-span">
      <Image
        {...props}
        src={inView ? props.src : PLACEHOLDER_IMAGE}
        loading="eager"
        quality={60}
      />
    </div>
  );
};
// const firebaseEndpoint = 'https://firebasestorage.googleapis.com/';

// const imageLoader = ({ src, width, quality }: ImageProps) => {
//   let imagekitEndpoint = 'https://ik.imagekit.io/blumint';

//   src = src.slice(firebaseEndpoint.length);

//   if (src[0] === '/') src = src.slice(1);
//   const params = [`w-${width}`];
//   if (quality) {
//     params.push(`q-${quality}`);
//   }
//   const paramsString = params.join(',');
//   if (imagekitEndpoint[imagekitEndpoint.length - 1] === '/')
//     imagekitEndpoint = imagekitEndpoint.substring(
//       0,
//       imagekitEndpoint.length - 1,
//     );
//   return `${imagekitEndpoint}/tr:${paramsString}/${src}`;
// };

// export const ImageOptimized: React.FC<ImageProps> = (props) => {
//   /**
//    * if (props.src?.includes(firebaseEndpoint)) {
//     return <Image loader={imageLoader} {...props} />;
//   }
//    */
//   // eslint-disable-next-line jsx-a11y/alt-text
//   return <Image {...props} />;
// };

// export { imageLoader };
